import React from "react";
import { Routes, Route } from "react-router-dom";
import SalePipeline from "./index";
import TeamWorkspaceLayout from "../Team/components/TeamWorkspaceLayout";
import { TEAM_BASE } from "../../utils/teamNavigation";

export default function TeamSalesPipelineRoutes({ basePath = TEAM_BASE, standalone = false }) {
  return (
    <TeamWorkspaceLayout
      basePath={basePath}
      activeSection="salesPipeline"
      contentScroll
      standalone={standalone}
    >
      <Routes>
        <Route index element={<SalePipeline workspaceBasePath={basePath} />} />
        <Route path=":id" element={<SalePipeline workspaceBasePath={basePath} />} />
      </Routes>
    </TeamWorkspaceLayout>
  );
}
